(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (() => {
    const initializeArticleNavigation = (section) => {
      const navigation = section.querySelector('[data-article-navigation]');
      const articleContent = section.querySelector('.blog-post-content');

      if (!navigation || !articleContent || navigation.dataset.initialized === 'true') return;

      const linkList = navigation.querySelector('[data-article-navigation-links]');
      const toggle = navigation.querySelector('[data-article-navigation-toggle]');
      const maximumLinks = Number.parseInt(navigation.dataset.maxLinks || '10', 10);
      const headings = [...articleContent.querySelectorAll('h2')]
        .filter((heading) => !heading.closest('[data-article-navigation], .op-article-index'))
        .slice(0, maximumLinks);

      if (headings.length < 2 || !linkList || !toggle) return;

      const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
      const makeId = (text, index) => {
        const base = text
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '') || `section-${index + 1}`;
        let candidate = base;
        let suffix = 2;
        while (usedIds.has(candidate)) {
          candidate = `${base}-${suffix}`;
          suffix += 1;
        }
        usedIds.add(candidate);
        return candidate;
      };

      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = makeId(heading.textContent.trim(), index);
        heading.style.scrollMarginTop = 'calc(var(--header-height, 72px) + 96px)';

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        linkList.append(item);
      });

      articleContent.querySelectorAll('.op-article-index').forEach((embeddedNavigation) => {
        embeddedNavigation.hidden = true;
        embeddedNavigation.setAttribute('aria-hidden', 'true');
      });

      articleContent.parentNode.insertBefore(navigation, articleContent);
      navigation.hidden = false;
      navigation.dataset.initialized = 'true';

      const setExpanded = (expanded) => {
        toggle.setAttribute('aria-expanded', String(expanded));
        linkList.hidden = !expanded;
      };

      const shouldCollapseOnMobile = navigation.dataset.collapseMobile === 'true'
        && window.matchMedia('(max-width: 749px)').matches;
      setExpanded(!shouldCollapseOnMobile);

      toggle.addEventListener('click', () => {
        setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
      });

      linkList.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link) return;
        if (window.matchMedia('(max-width: 749px)').matches) setExpanded(false);
      });

      if ('IntersectionObserver' in window) {
        const links = [...linkList.querySelectorAll('a')];
        const linkById = new Map(links.map((link) => [decodeURIComponent(link.hash.slice(1)), link]));
        const observer = new IntersectionObserver((entries) => {
          const visibleHeading = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
          if (!visibleHeading) return;
          links.forEach((link) => link.removeAttribute('aria-current'));
          linkById.get(visibleHeading.target.id)?.setAttribute('aria-current', 'location');
        }, { rootMargin: '-18% 0px -68% 0px', threshold: 0 });
        headings.forEach((heading) => observer.observe(heading));
      }
    };

    const initializeCurrentSection = () => {
      document.querySelectorAll('.section-wrapper').forEach(initializeArticleNavigation);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCurrentSection, { once: true });
    } else {
      initializeCurrentSection();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeArticleNavigation(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
